module.exports = __webpack_public_path__ + "img/SA.2dd9486f.svg";